/**
 * Created by Yangxunwu on 2018/6/7.
 * url跳转时进行验证,判断是否有token如果没有进入登录页面，如果有进入对应的路由页面
 */

import router from './router'
import store from "./store"
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken, getFinishRegister } from '@/utils/auth' // getToken from cookie

NProgress.configure({ showSpinner: false })// NProgress Configuration

const whiteList = ['/account', '/account/register', '/', '/account/login'] // no redirect whitelist

router.beforeEach((to, from, next) => {

	console.log(from, to);
	NProgress.start()

	if (getToken()) {


		//已登录用户点击登录注册时跳转主页
		if ((to.path === '/account/login') || (to.path === '/account/register')) {

			next({ path: '/' })
			NProgress.done()

		} else {

			if(to.path === '/finishRegister' && !getFinishRegister()) {
				next();
			}else if(to.path === '/finishRegister' && getFinishRegister()){

				next({path: "/salary/new"})
			} else{

                if(!getFinishRegister() || to.path === '/') {
	                //跳转首页
	                next()
	                NProgress.done()
                }else if(!getFinishRegister()) {
					//如果没有完成注册跳转到完成注册界面
	                next({path: '/finishRegister'});
                }else{
	                //认证通过直接访问
	                next();
                }
			}

            NProgress.done()
		}

	} else {

	    console.log('to.meta.needAuth', to.meta.needAuth );

		// 在免登录白名单，直接进入
		if (whiteList.indexOf(to.path) !== -1 || to.meta.needAuth === false) {
		    console.log('白名单');
			next()
		} else {

			// 未认证用户,重定向到登录页
			console.log('未认证用户,重定向到登录页');
			next('/account/login')
			NProgress.done()
		}
	}
})

router.afterEach(() => {
	NProgress.done() // finish progress bar
})




// WEBPACK FOOTER //
// ./src/routercheck.js